export enum SessionStorageKeys {
	NavigateAfterLogin = 'nav-after-login',
}
